import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import {
  makeLink,
  getAssetClassColor,
  getSiteColor,
} from './fundCardUtilities.jsx'
import './fundCard.css'

import { CardContent } from './CardContent.jsx'
import { FooterContent } from './FooterContent.jsx'

const FundCard = forwardRef(function FundCard(props, minHeightRef) {
  const { card, minHeight, children } = props
  const fundName = card?.fundName
  const ticker = card?.ticker
  const category = card?.category
  const body = card?.body
  const assetClass = card?.assetClass
  const highlightColor = card?.highlightColor
  const footerText = card?.footerText
  const footerTitle = card?.footerTitle
  const footerContentCollapsed = card?.footerContentCollapsed
  const rating = card?.rating
  const target = card?.cta?.target ? card?.cta?.target : 'self'
  const href = card?.cta?.Link?.[0]?.string
  const Link = href && makeLink(href, target)
  const fundColor =
    highlightColor === 'siteColor'
      ? getSiteColor()
      : highlightColor === 'assetClass'
        ? getAssetClassColor(assetClass)
        : ''

  const color = fundColor === '' ? fundColor : ` ${fundColor}`
  return href ? (
    <div
      className={`Card-with-hover Card u-flexGrow1 u-posRelative${color}`}
      data-analytics="fund-card-feature-fund"
    >
      {children}
      <Link data-analytics="fund-card-feature-fund-link">
        <CardContent
          rating={rating}
          fundName={fundName}
          href={href}
          ticker={ticker}
          category={category}
          body={body}
          minHeight={minHeight}
          ref={minHeightRef}
        />
      </Link>
      <FooterContent
        footerTitle={footerTitle}
        footerText={footerText}
        footerContentCollapsed={footerContentCollapsed}
      />
    </div>
  ) : (
    <div
      className={`Card u-posRelative${color}`}
      data-analytics="fund-card-feature-fund"
    >
      {children}
      <CardContent
        rating={rating}
        fundName={fundName}
        href={href}
        ticker={ticker}
        category={category}
        body={body}
        ref={minHeightRef}
        minHeight={minHeight}
      />
      <FooterContent
        footerTitle={footerTitle}
        footerText={footerText}
        footerContentCollapsed={footerContentCollapsed}
      />
    </div>
  )
})

FundCard.propTypes = {
  card: PropTypes.shape({
    fundName: PropTypes.string,
    ticker: PropTypes.string,
    category: PropTypes.string,
    body: PropTypes.string,
    rating: PropTypes.string,
    cta: PropTypes.object,
    assetClass: PropTypes.string,
    highlightColor: PropTypes.string,
    footerText: PropTypes.string,
    footerTitle: PropTypes.string,
    footerContentCollapsed: PropTypes.bool,
  }),
  children: PropTypes.object,
  minHeight: PropTypes.number,
  minHeightRef: PropTypes.object,
}

export default FundCard
